export default angular
  .module("UserCtrl", ["angularUtils.directives.dirPagination", "ui.bootstrap"])
  .controller("UserController", [
    "$scope",
    "$modal",
    "$state",
    "$http",
    "$rootScope",
    "$translate",
    "$filter",
    "System",
    "Users",
    "Permissions",
    "modal",
    function (
      $scope,
      $modal,
      $state,
      $http,
      $rootScope,
      $translate,
      $filter,
      System,
      Users,
      Permissions,
      modal,
    ) {
      // Set starting day to monday
      $scope.calendarOptions = {
        "starting-day": "1",
      };

      $scope.calendarOpen = [];
      $scope.emailRankingOptions = [0, 1, 2, 3, 4, 5, 6];

      // Toggles the pop-up date picker for selecting start date.
      $scope.openCalendar = function ($event, index) {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.calendarOpen[index] = !$scope.calendarOpen[index];
      };

      $rootScope.page = "users";
      $scope.sortUsers = [];
      $scope.sortUsers.column = "USER_FULL_NAME";
      $scope.sortUsers.direction = false; // ascending direction

      $scope.getApplicationRightLevels = ({ APPLICATION }) =>
        Permissions.getRightLevelsForApplication(APPLICATION);

      System.loadUsers((data) => {
        $scope.users = data;
      });

      System.loadCountries((data) => {
        $scope.countries = data;
      });

      System.loadLanguages((data) => {
        $scope.languages = data;
      });

      // Sets table sort according to COLUMN
      // Also toggles between ascending and descending
      $scope.changeSorting = function (column) {
        if ($scope.sortUsers.column == column) {
          $scope.sortUsers.direction = !$scope.sortUsers.direction;
        } else {
          $scope.sortUsers.column = column;
          $scope.sortUsers.direction = false;
        }
      };

      // load content groups for ngtags form element in modal window.
      $scope.loadContentGroupTags = function (query) {
        return $http
          .get("/api/contentprovidersname/", { cache: true })
          .then((response) => {
            const contents = response.data;
            return contents.filter(content => (
              content.LONG_NAME.toLowerCase().indexOf(query.toLowerCase()) !==
                -1
            ));
          });
      };

      // load organizations for ngtags form element in modal window.
      $scope.loadOrganizationTags = function (query) {
        return $http
          .get("/api/organizations/", { cache: true })
          .then((response) => {
            const contents = response.data;
            return contents.filter(content => (
              content.NAME.toLowerCase().indexOf(query.toLowerCase()) !== -1
            ));
          });
      };

      // load national scripts for ngtags form element in modal window.
      $scope.loadNationalScriptsTags = function (query) {
        return $http
          .get("/api/countries/", { cache: true })
          .then((response) => {
            const countries = response.data;
            return countries.filter(country => (
              country.NAME.toLowerCase().indexOf(query.toLowerCase()) !== -1
            ));
          });
      };

      // user clicked a user and details are shown.
      $scope.openUser = function (user) {
        $scope.selectedUser = user;

        $scope.selectedUser.allProviders = $scope.selectedUser.CONTENT_GROUPS === ",All,";
        if ($scope.selectedUser.CONTENT_GROUPS && !$scope.selectedUser.allProviders) {
          $scope.selectedUser.CONTENT_GROUPS_SPLITTED =
            $scope.selectedUser.CONTENT_GROUPS.split(",").filter(group => group.length > 0);
        } else {
          $scope.selectedUser.CONTENT_GROUPS_SPLITTED = [];
        }

        $scope.selectedUser.allNations = $scope.selectedUser.NATIONAL_SCRIPTS === ",All,";
        if ($scope.selectedUser.NATIONAL_SCRIPTS && !$scope.selectedUser.allNations) {
          $scope.selectedUser.NATIONAL_SCRIPTS_SPLITTED =
            $scope.selectedUser.NATIONAL_SCRIPTS.split(",").filter(group => group.length > 0);
        } else {
          $scope.selectedUser.NATIONAL_SCRIPTS_SPLITTED = [];
        }

        // user rights
        System.loadUserRights($scope.selectedUser.ID, (data) => {
          $scope.userrights = Permissions.applications
            .map(app => ({ USER_ID: $scope.selectedUser.ID, APPLICATION: app, RIGHT_LEVEL: 0 }));

          for (let i = 0; data.length > i; i++) {
            for (let j = 0; $scope.userrights.length > j; j++) {
              if (data[i].APPLICATION === $scope.userrights[j].APPLICATION) {
                $scope.userrights[j].ID = data[i].ID;
                $scope.userrights[j].RIGHT_LEVEL = data[i].RIGHT_LEVEL;
                if (data[i].EXPIRATION_DATE) {
                  $scope.userrights[j].EXPIRATION_DATE = new Date(data[i].EXPIRATION_DATE);
                } else {
                  $scope.userrights[j].EXPIRATION_DATE = "";
                }
              }
            }
          }
        });

        // user organizations
        System.loadUserOrganizations($scope.selectedUser.ID, (data) => {
          $scope.selectedUser.Organizations = data;
        });
        $rootScope.userSelected = true;
      };

      const buildSplitText = (split) => {
        if (!split || split.length === 0) {
          return "";
        }

        const texts = split.map(r => r.text).join(",");
        return `,${texts},`;
      };

      $scope.saveUserChanges = () => {
        $scope.selectedUser.CONTENT_GROUPS =
          $scope.selectedUser.allProviders ? ",All," : buildSplitText($scope.selectedUser.CONTENT_GROUPS_SPLITTED);
        $scope.selectedUser.NATIONAL_SCRIPTS =
          $scope.selectedUser.allNations ? ",All," : buildSplitText($scope.selectedUser.NATIONAL_SCRIPTS_SPLITTED);

        $scope.selectedUser.accessRights = [];
        for (let i = 0; i < $scope.userrights.length; i++) {
          const newRight = {};
          angular.copy($scope.userrights[i], newRight);
          if ($scope.userrights[i].EXPIRATION_DATE) {
            newRight.EXPIRATION_DATE = $filter("date")(
              newRight.EXPIRATION_DATE,
              "dd-MMM-yy",
            );
          }
          $scope.selectedUser.accessRights.push(newRight);
        }
        Users.updateUser($scope.selectedUser, () => {});
      };

      $rootScope.deleteUser = () => {
        const userFullName = $scope.selectedUser.USER_FULL_NAME;
        modal.createConfirmationModal(
          `Deleting user: ${userFullName}`,
          `Are you sure you want to delete ${userFullName}?`,
        ).result
          .then(({ action }) => {
            if (action === "confirm") {
              Users.deleteUser($scope.selectedUser, () => {
                System.loadUsers((data) => {
                  $scope.users = data;
                  $rootScope.userSelected = false;
                  $scope.selectedUser = {};
                });
              });
            }
          });
      };

      const saveUserChangeListener = $rootScope.$on("saveUserChanges", $scope.saveUserChanges);
      $scope.$on("$destroy", saveUserChangeListener);

      const deleteUserListener = $rootScope.$on("deleteUser", $scope.deleteUser);
      $scope.$on("$destroy", deleteUserListener);
    },
  ]);
